import { render, staticRenderFns } from "./ModuleIcon.vue?vue&type=template&id=cc68e04c"
import script from "./ModuleIcon.vue?vue&type=script&lang=js"
export * from "./ModuleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports